<template>
  <b-row>
    <b-col lg="3" md="4" sm="6" xl="2">
      <b-form-group
        :label="$t('user.otherCode')"
        label-for="user-otherCode"
      >
        <b-form-input
          id="user-otherCode"
          v-model="otherCode"
          aria-describedby="user-otherCode-feedback"
        />
      </b-form-group>
    </b-col>
    <b-col lg="3" md="4" sm="6" xl="2">
      <b-form-group
        :invalid-feedback="
          invalidTypeOfIdentificationDocument
            ? $t(`validation.${invalidTypeOfIdentificationDocument}`, {
                field: $t('user.typeOfIdentificationDocument'),
              })
            : ''
        "
        :label="$t('user.typeOfIdentificationDocument')"
        :state="v.typeOfIdentificationDocument.$dirty ? ((!v.typeOfIdentificationDocument.$invalid === false) ? false : null) : null"
        :class="{ 'required-group': !v.typeOfIdentificationDocument.required }"
        label-for="user-typeOfIdentificationDocument"
      >
        <my-v-select
            :key="typeOfIdentificationDocument"
            id="user-typeOfIdentificationDocument"
            v-model="typeOfIdentificationDocument"
            :multiple="false"
            :options="typeOfIdentificationDocuments"
            :translate="true"
            :concat-label="['text']"
            :reduce-field="['text']"
            translateObj='user.typeOfIdentificationDocuments'
            :searchable="true"
            :filterable="true"
        />
<!--        <b-form-input-->
<!--          id="typeOfIdentificationDocument"-->
<!--          v-model="typeOfIdentificationDocument"-->
<!--          :state="-->
<!--            v.typeOfIdentificationDocument.$dirty-->
<!--              ? !v.typeOfIdentificationDocument.$invalid-->
<!--              : null-->
<!--          "-->
<!--        />-->
      </b-form-group>
    </b-col>
    <b-col lg="3" md="4" sm="6" xl="2">
      <b-form-group
        :label="$t('user.expiryDateOfIdentityDocument')"
        label-for="user-expiryDateOfIdentityDocument"
      >
        <my-cleave-date @input="val => expiryDateOfIdentityDocument = val" >
        </my-cleave-date>
<!--        <my-ab-date-picker-->
<!--          v-model="expiryDateOfIdentityDocument"-->
<!--          :auto-submit="true"-->
<!--          :column="1"-->
<!--          :locale="'en'"-->
<!--          :mode="'single'"-->
<!--          :show="false"-->
<!--          :to="'1499'"-->
<!--          :type="'date'"-->
<!--          clearable-->
<!--          click-on="all"-->
<!--        >-->
<!--        </my-ab-date-picker>-->
      </b-form-group>
    </b-col>
    <b-col v-if="isForeigner && isArabCountry" lg="3" md="4" sm="6" xl="2">
      <b-form-group
        :invalid-feedback="
          invalidForefatherName
            ? $t(`validation.${invalidForefatherName}`, {
                field: $t('user.forefatherName'),
              })
            : ''
        "
        :label="$t('user.forefatherName')"
        :state="v.forefatherName.$dirty ? ((!v.forefatherName.$invalid === false) ? false : null) : null"
        :class="{ 'required-group': !v.forefatherName.required }"
        label-for="user-forefatherName"
      >
        <b-form-input
          id="user-forefatherName"
          v-model="forefatherName"
          :state="v.forefatherName.$dirty ? !v.forefatherName.$invalid : null"
        />
      </b-form-group>
    </b-col>
<!--     JUST TEST GIT -->
    <b-col cols="12">
      <my-vue-upload-component
        :reference="'citizen_identification_document-create'"
        :description="true"
        :files="filesList"
        accept="image/png, image/gif, image/jpeg, image/webp"
        :add-a-file-mutation="'user/ADD_TO_FILES_LIST'"
        :edit-a-file-mutation="'user/EDIT_FILES_LIST'"
        :remove-a-file-mutation="'user/ADD_TO_REMOVAL_FILES'"
        :attachedPayloadMutation="'user/ADD_TO_ATTACHED_PAYLOAD'"
        :addedFilesMutation="'user/ADD_TO_ADDED_FILES'"
        :payloadProps="['description', 'file']"

      >
      </my-vue-upload-component>
    </b-col>
  </b-row>
</template>

<script>
import dateFormat from "@/mixins/dateFormat";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BPopover,
  VBPopover,
} from "bootstrap-vue";
import MyAbDatePicker from "@/components/wrapper/datePicker/MyAbDatePicker";
import Ripple from "vue-ripple-directive";
import MyVueUploadComponent from "@/components/wrapper/uploader/MyVueUploadComponent";
import MyVSelect from "@/components/wrapper/select/MyVSelect";
import MyCleaveDate from "@/components/wrapper/datePicker/MyCleaveDate";

export default {
  data: () => ({
    // attachedPayload: []
  }),
  components: {
    MyVSelect,
    MyVueUploadComponent,
    MyAbDatePicker,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BPopover,
    BButton,
    MyCleaveDate
  },
  directives: {
    Ripple,
    "b-popover": VBPopover,
  },
  methods: {
    inputUpdate(file) {
    },
    // inputFile: function (newFile, oldFile) {
    //   if (newFile && oldFile && !newFile.active && oldFile.active) {
    //     // Get response data
    //     if (newFile.xhr) {
    //       //  Get the response status code
    //     }
    //   }
    // },
    /**
     * Pretreatment
     * @param  Object|undefined   newFile   Read and write
     * @param  Object|undefined   oldFile   Read only
     * @param  Function           prevent   Prevent changing
     * @return undefined
     */
    inputFilter: function (newFiles) {
      // if (newFile && !oldFile) {
      //   // Filter non-image file
      //   if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
      //     return prevent()
      //   }
      // }
      // Create a blob field\
      newFiles.forEach((newFile) => {
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        newFile.url = "";
        if (newFile.blob) {
          newFile.url = newFile.blob;
        }
        this.$store.commit("user/ADD_TO_ALL_FILES", newFile);
        // this.$refs.upload.add(newFile)
      });
    },
  },
  computed: {
    userToEdit: {
      set(userToEdit) {
        this.$store.commit("user/SET_USER_TO_EDIT", userToEdit);
      },
      get() {
        return this.$store.getters["user/userToEdit"];
      },
    },
    allFiles: {
      set(files) {
        this.$store.commit("user/SET_ALL_FILES", files);
      },
      get() {
        return this.$store.getters["user/allFiles"];
      },
    },
    filesList: {
      set(files) {
        this.$store.commit("user/SET_FILES_LIST", files);
      },
      get() {
        return this.$store.getters["user/filesList"];
      },
    },
    otherCode: {
      set(otherCode) {
        this.$store.commit("user/SET_OTHERCODE", otherCode);
      },
      get() {
        return this.$store.getters["user/otherCode"];
      },
    },
    expiryDateOfIdentityDocument: {
      set(expiryDateOfIdentityDocument) {
        this.$store.commit(
          "user/SET_EXPIRY_DATE_OF_IDENTITY_DOCUMENT",
          expiryDateOfIdentityDocument
        );
      },
      get() {
        return this.$store.getters["user/expiryDateOfIdentityDocument"];
      },
    },
    typeOfIdentificationDocuments: {
      set(typeOfIdentificationDocuments) {
        this.$store.commit(
          "user/SET_TYPE_OF_IDENTIFICATION_DOCUMENTS",
          typeOfIdentificationDocuments
        );
      },
      get() {
        return this.$store.getters["user/typeOfIdentificationDocuments"];
      },
    },
    typeOfIdentificationDocument: {
      set(typeOfIdentificationDocument) {
        this.$store.commit(
          "user/SET_TYPE_OF_IDENTIFICATION_DOCUMENT",
          typeOfIdentificationDocument
        );
      },
      get() {
        return this.$store.getters["user/typeOfIdentificationDocument"];
      },
    },
    forefatherName: {
      set(forefatherName) {
        this.$store.commit("user/SET_FOREFATHER_NAME", forefatherName);
      },
      get() {
        return this.$store.getters["user/forefatherName"];
      },
    },
    // invalidFeedbackExpiryDateOfIdentityDocument: {
    //   set(error) {},
    //   get() {
    //     var error = "";
    //     if (!this.v.expiryDateOfIdentityDocument.$dirty) return error;
    //     if (!this.v.expiryDateOfIdentityDocument.required) error = "required";
    //     return error;
    //   },
    // },
    invalidTypeOfIdentificationDocument: {
      set(error) {},
      get() {
        var error = "";
        if (!this.v.typeOfIdentificationDocument.$dirty) return error;
        if (!this.v.typeOfIdentificationDocument.required) error = "required";
        return error;
      },
    },
    invalidForefatherName: {
      set(error) {},
      get() {
        var error = "";
        if (!this.v.forefatherName.$dirty) return error;
        if (!this.v.forefatherName.required) error = "required";
        return error;
      },
    },
    invalidFeedbackOtherCode: {
      set(error) {},
      get() {
        var error = "";
        if (!this.v.otherCode.$dirty) return error;
        if (!this.v.otherCode.minLength) error = "min";
        if (!this.v.otherCode.required) error = "required";
        return error;
      },
    },
  },
  props: {
    // files: {
    //   default() {
    //     return []
    //   },
    // },
    v: {},
    isForeigner: {
      default: "",
    },
    isArabCountry: {
      default: false,
    },
  },
  mixins: [dateFormat],
};
</script>

<style>
/*.example-full .btn-group .dropdown-menu {*/
/*  display: block;*/
/*  visibility: hidden;*/
/*  transition: all .2s*/
/*}*/

/*.example-full .btn-group:hover > .dropdown-menu {*/
/*  visibility: visible;*/
/*}*/

/*.example-full label.dropdown-item {*/
/*  margin-bottom: 0;*/
/*}*/

/*.example-full .btn-group .dropdown-toggle {*/
/*  margin-right: .6rem*/
/*}*/

/*.td-image-thumb {*/
/*  max-width: 4em;*/
/*  max-height: 4em;*/
/*}*/

/*.example-full .filename {*/
/*  margin-bottom: .3rem*/
/*}*/

/*.example-full .btn-is-option {*/
/*  margin-top: 0.25rem;*/
/*}*/

/*.example-full .example-foorer {*/
/*  padding: .5rem 0;*/
/*  border-top: 1px solid #e9ecef;*/
/*  border-bottom: 1px solid #e9ecef;*/
/*}*/

/*.example-full .edit-image img {*/
/*  max-width: 100%;*/
/*}*/

/*.example-full .edit-image-tool {*/
/*  margin-top: .6rem;*/
/*}*/

/*.example-full .edit-image-tool .btn-group {*/
/*  margin-right: .6rem;*/
/*}*/

/*.example-full .footer-status {*/
/*  padding-top: .4rem;*/
/*}*/

/*.example-full .drop-active {*/
/*  top: 0;*/
/*  bottom: 0;*/
/*  right: 0;*/
/*  left: 0;*/
/*  position: fixed;*/
/*  z-index: 9999;*/
/*  opacity: .6;*/
/*  text-align: center;*/
/*  background: #000;*/
/*}*/

/*.example-full .drop-active h3 {*/
/*  margin: -.5em 0 0;*/
/*  position: absolute;*/
/*  top: 50%;*/
/*  left: 0;*/
/*  right: 0;*/
/*  -webkit-transform: translateY(-50%);*/
/*  -ms-transform: translateY(-50%);*/
/*  transform: translateY(-50%);*/
/*  font-size: 40px;*/
/*  color: #fff;*/
/*  padding: 0;*/
/*}*/
</style>
